export default __webpack_public_path__ + "static/media/intro_background_updated.4b02ea11.png";